// extracted by mini-css-extract-plugin
export var darkBg = "SelectLanguage-module--darkBg--b9321";
export var wrapper = "SelectLanguage-module--wrapper--3ee81";
export var wrapperInMenu = "SelectLanguage-module--wrapperInMenu--21c58";